import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getUserDetails = createAsyncThunk(
    'userDetails/getUserDetails',
    async ({ userId, token }, { rejectWithValue }) => {
    try {
        console.log('getUserDetails - userId:', userId);
        console.log('getUserDetails - token:', token ? 'presente' : 'non presente');
        
        const url = `${import.meta.env.VITE_API_BASE_URL}/users?userId=${userId}`;
        const headers = { 'Content-Type': 'application/json', 'auth-token': token };
        const options = { method: 'GET', headers };
        
        console.log('getUserDetails - URL:', url);
        console.log('getUserDetails - headers:', JSON.stringify(headers));
        
        const response = await fetch(url, options);
        console.log('getUserDetails - response status:', response.status);
        
        if (!response.ok) {
            const error = await response.json();
            console.error('getUserDetails - error:', error);
            return rejectWithValue({
                message: error.message || `Errore sconosciuto.`
            })
        } else {
            const result = await response.json();
            console.log('getUserDetails - result:', result);
            return result
        }
    } catch (error) {
        console.error('getUserDetails - catch error:', error);
        return rejectWithValue({
            message: (error instanceof Error) ? error.message : 'Errore di rete. Riprova più tardi.'
        });
    }
})

const userDetailsSlice = createSlice({
    name: "userDetails",
    initialState: {
        isLoading: false,
        error: null,
        data: null
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserDetails.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getUserDetails.rejected, (state, action) => {
                state.data = null;
                state.error = action.payload?.message || "Errore sconosciuto nel caricamento dei dettagli utente.";
                state.isLoading = false;
            })
            .addCase(getUserDetails.fulfilled, (state, action) => {
                state.error = null;
                state.data = action.payload;
                state.isLoading = false;
            })
    }
})

// Selectors
export const selectUserDetailsData = (state) => state.userDetails.data;
export const selectUserDetailsIsLoading = (state) => state.userDetails.isLoading;
export const selectUserDetailsError = (state) => state.userDetails.error;

export default userDetailsSlice.reducer;
